import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="bg-[#20222D] border-t border-gray-800 pt-16 pb-8 px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
                <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
                    {/* Brand Column */}
                    <div className="lg:col-span-1">
                        <img src="/assets/images/logo-transparent.png" alt="BPO Consultants" className="h-10 mb-4" />
                        <p className="text-gray-400 text-sm mb-4">
                            Your trusted partner for AI-augmented offshore staffing and BPO solutions in the Philippines.
                        </p>
                        <div className="flex space-x-4">
                            {/* Social Icons would go here */}
                        </div>
                    </div>

                    <div className="lg:col-span-1">
                        <h4 className="text-white font-bold mb-4">Solutions</h4>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/services/ai-staffing" className="text-gray-400 hover:text-[#A2CB52] transition-colors">AI-Augmented Staffing</Link></li>
                            <li><Link to="/services/cost-optimization" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Cost Optimization</Link></li>
                            <li><Link to="/services/offshore-strategy" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Offshore Strategy</Link></li>
                            <li><Link to="/services/digital-transformation" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Digital Transformation</Link></li>
                        </ul>
                    </div>

                    <div className="lg:col-span-2">
                        <h4 className="text-white font-bold mb-4">Industries</h4>
                        <ul className="grid grid-cols-2 gap-x-8 gap-y-2 text-sm">
                            <li><Link to="/industries/technology" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Technology & IT</Link></li>
                            <li><Link to="/industries/healthcare" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Healthcare & Medical</Link></li>
                            <li><Link to="/industries/retail" className="text-gray-400 hover:text-[#A2CB52] transition-colors">E-commerce & Retail</Link></li>
                            <li><Link to="/industries/finance" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Financial Services</Link></li>
                            <li><Link to="/industries/construction" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Construction</Link></li>
                            <li><Link to="/industries/education" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Education</Link></li>
                            <li><Link to="/industries/engineering" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Engineering</Link></li>
                            <li><Link to="/industries/hr" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Human Resources</Link></li>
                            <li><Link to="/industries/legal" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Legal Services</Link></li>
                            <li><Link to="/industries/logistics" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Logistics & Supply Chain</Link></li>
                            <li><Link to="/industries/manufacturing" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Manufacturing</Link></li>
                            <li><Link to="/industries/marketing" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Marketing & Advertising</Link></li>
                            <li><Link to="/industries/media" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Media & Entertainment</Link></li>
                            <li><Link to="/industries/operations" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Operations & Support</Link></li>
                            <li><Link to="/industries/real-estate" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Real Estate</Link></li>
                            <li><Link to="/industries/sales" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Sales & Biz Dev</Link></li>
                            <li className="col-span-2"><Link to="/industries/travel" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Travel & Hospitality</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-white font-bold mb-4">Resources</h4>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/glossary" className="text-gray-400 hover:text-[#A2CB52] transition-colors">BPO Glossary</Link></li>
                            <li><Link to="/case-studies" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Case Studies</Link></li>
                            <li><Link to="/blog" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Blog & Insights</Link></li>
                            <li><Link to="/training" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Free Training</Link></li>
                            <li><Link to="/training/webinars" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Webinars</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8 pt-8 border-t border-gray-700">
                    <div>
                        <h4 className="text-white font-bold mb-4">Company</h4>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/about" className="text-gray-400 hover:text-[#A2CB52] transition-colors">About Us</Link></li>
                            <li><Link to="/careers" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Careers</Link></li>
                            <li><Link to="/contact" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Contact Us</Link></li>
                        </ul>
                    </div>


                    <div>
                        <h4 className="text-white font-bold mb-4">Legal</h4>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/privacy-policy" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Privacy Policy</Link></li>
                            <li><Link to="/terms-of-service" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Terms of Service</Link></li>
                            <li><Link to="/cookie-policy" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Cookie Policy</Link></li>
                            <li><Link to="/gdpr-compliance" className="text-gray-400 hover:text-[#A2CB52] transition-colors">GDPR Compliance</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-white font-bold mb-4">Connect</h4>
                        <ul className="space-y-2 text-sm mb-4">
                            <li><a href="https://www.linkedin.com/in/bpo-consultants-undefined-b332143b2/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#A2CB52] transition-colors">LinkedIn</a></li>
                            <li><a href="https://x.com/bpoconsultants_" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#A2CB52] transition-colors">Twitter / X</a></li>
                            <li><a href="https://www.youtube.com/@BPOConsultants" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#A2CB52] transition-colors">YouTube</a></li>
                        </ul>
                        <p className="text-gray-400 text-xs">
                            📧 info@bpoconsultants.ph<br />
                            📞 Contact for Details
                        </p>
                    </div>
                </div>

                <div className="border-t border-gray-700 pt-8 text-center">
                    <p className="text-gray-400 text-sm">
                        © 2026 BPO Consultants. All rights reserved. | Empowering businesses through AI-augmented Philippine offshore excellence.
                    </p>

                </div>
            </div>
        </footer>
    );
};

export default Footer;
